"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.jane.description': 'Młoda, ciepła, gładka i przyjazna kobieta.',
};
